import { gsap } from 'gsap';
import React from 'react';
import styled from 'styled-components';

import { PageBodyBlock_Photo_Full_BleedPrimary } from '../../../types/prismic';
import { media } from '../../styles/media';

interface BlockPhotoFullBleedProps {
  slice: {
    primary: PageBodyBlock_Photo_Full_BleedPrimary;
  };
  sliceIndex: number;
}

const BlockPhotoFullBleed: React.FunctionComponent<
  BlockPhotoFullBleedProps
> = ({
  slice: {
    primary: { image },
  },
  sliceIndex,
}) => {
  const sliceId = `block-photo-full-bleed-${sliceIndex}`;
  const bgClassName = `bg--photo--full--bleed-${sliceIndex}`;

  React.useEffect(() => {
    const fadeElements = gsap.timeline();
    fadeElements.from(
      `#${sliceId} .bg--holder`,
      {
        duration: 0.6,
        opacity: '0',
      },
      '-=0.4'
    );
    fadeElements.to(`#${sliceId} .bg--holder`, {
      opacity: 1,
      delay: 0.25,
    });
    const bg = document.querySelector(`.${bgClassName}`);
    const bgTL = gsap.timeline({
      scrollTrigger: {
        trigger: `#${sliceId}`,
        scrub: 1,
        start: 'top 90%',
      },
    });
    bgTL.fromTo(bg, { scale: 1.1 }, { scale: 1, force3D: true }, 0);
  }, []);

  return (
    <Section id={sliceId} className="relative 2xl:mx-auto 2xl:max-w-[1120px]">
      <div className="bg--holder md:block">
        <BackgroundImage
          className={bgClassName}
          style={{ backgroundImage: `url(${image?.url})` }}
        />
      </div>
    </Section>
  );
};

const BackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: var(--grey-2);
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;
  overflow: hidden;
`;

const Section = styled.section`
  position: relative;
  overflow: hidden;
  .bg--holder {
    position: relative;
    width: 100%;
    height: 305px;
    overflow: hidden;
    background: var(--accent-1);
    @media ${media.mdUp} {
      height: 368px;
    }
    @media ${media.lgUp} {
      height: 600px;
    }
  }
`;

export default BlockPhotoFullBleed;
